import React from "react";

const TONES = {
  brand: "bg-brand-100 text-brand-700 dark:bg-brand-900/40 dark:text-brand-200",
  info: "bg-info-subtle text-info-fg",
  success: "bg-success-subtle text-success-fg",
  warning: "bg-warning-subtle text-warning-fg",
};

const SIZES = {
  md: { tile: "h-10 w-10", icon: "h-5 w-5" },
  lg: { tile: "h-12 w-12", icon: "h-6 w-6" },
  xl: { tile: "h-16 w-16", icon: "h-9 w-9" },
};

/** Round tinted icon badge used on the survey result cards. */
const IconTile = ({ icon: Icon, tone = "brand", size = "md", className = "" }) => {
  const { tile, icon } = SIZES[size] || SIZES.md;
  return (
    <span
      className={`flex shrink-0 items-center justify-center rounded-full ${tile} ${TONES[tone] || TONES.brand} ${className}`.trim()}
    >
      <Icon aria-hidden="true" className={icon} />
    </span>
  );
};

export default IconTile;
